<template>
  <div class="sidebar-menu fixed mw-100 c-bg-black c-white pt20">
    <div class="row px20 pb20 c-bg-black">
      <div class="w-100 flex relative center-xs">
        <div
          class="logo-container"
          @click="close"
        >
          <logo
            width="auto"
            height="41px"
          />
        </div>
        <button
          type="button"
          :aria-label="$t('Close')"
          class="inline-flex end-xs brdr-none p0 close-btn absolute right-0 c-bg-transparent"
          @click="close"
        >
          <i class="icon icon-close fs12 p15 c-white" />
        </button>
      </div>
    </div>
    <div
      ref="container"
      class="sidebar-menu__container row"
    >
      <div class="col-xs-12 h4 flex flex-wrap">
        <ul
          class="p0 m0 relative sidebar-menu__list w-100 pt20 px40"
          :style="mainListStyles"
        >
          <router-link
            class="block c-white c-bg-transparent"
            :to="categoryLink(getAllCategory)"
            @click.native="close"
          >
            {{ getAllCategory.name }}
          </router-link>
          <sidebar-dropdown
            v-for="(menu, index) in menuItems"
            :key="index"
            :list="menu.list"
            :category="menu.category"
            @close-sidebar="close"
          />
        </ul>
        <div class="account-details w-100 flex bottom-xs">
          <div class="w-100 brdr-top-1 c-brdr-grayscale-dark details pb30">
            <ul
              v-if="isLoggedIn"
              class="p0 m0 px30"
            >
              <div class="block align-left c-white fs20 lh22 bold pb15 pt30">
                {{ currentUser.firstname }}
                {{ currentUser.lastname }}
              </div>
              <div
                v-for="link in myAccountLinks"
                :key="link.id"
                class="c-white flex align-left"
              >
                <router-link
                  class="block w-100 c-white no-underline fs18 lh19 pt10 pb10"
                  :to="localizedRoute(link.url)"
                  @click.native="close"
                >
                  <div class="flex left">
                    <i
                      class="icon fs20 mr10"
                      :class="[link.icon]"
                    />
                    <span>{{ link.name }}</span>
                  </div>
                </router-link>
              </div>
              <li
                class="c-white flex align-left"
                @click="close"
              >
                <a
                  class="block fs18 lh19 w-100 pt10 pb0 c-white no-underline flex left"
                  @click.prevent="logout"
                >
                  <div class="flex left">
                    <i class="icon fs20 mr10 icon-log-out" />
                    <span>{{ $t('Log out') }}</span>
                  </div>
                </a>
              </li>
            </ul>
            <div
              v-else
              class="w-100 block px20"
            >
              <span class="c-white block fs18 lh22 align-center bold pb20 pt30">
                {{ $t('Already have account?') }}
              </span>
              <button
                v-if="!currentUser && isCurrentMenuShowed"
                class="button button-primary w-100 px25 py10 c-white no-underline fs16 lh19"
                @click="login"
              >
                {{ $t('Log in') }}
              </button>
              <div class="block align-center fs16 lh19 pt20">
                <span class="c-white">{{ $t('Don’t have an account?') }}</span>
                <a
                  class="c-primary bold fs16 lh19"
                  @click="goToRegisterPage()"
                >
                  {{ $t('Create an account') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SidebarMenu from '@vue-storefront/core/compatibility/components/blocks/SidebarMenu/SidebarMenu'
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import Logo from 'theme/components/core/Logo'
import { AccountButton } from '@vue-storefront/core/modules/user/components/AccountButton'
import ScrollLock from 'theme/mixins/scrollLock'
import SidebarDropdown from 'theme/components/theme/blocks/SidebarDropdown'
import Menu from 'theme/mixins/menu'

export default {
  name: 'SidebarMenu',
  components: {
    Logo,
    SidebarDropdown
  },
  mixins: [SidebarMenu, AccountButton, ScrollLock, Menu],
  data () {
    return {
      myAccountLinks: [
        {
          id: 1,
          name: this.$t('My account'),
          url: '/my-account',
          icon: 'icon-account'
        },
        {
          id: 2,
          name: this.$t('My orders'),
          url: '/my-account/orders',
          icon: 'icon-tickets-white'
        }
      ],
      componentLoaded: false
    }
  },
  computed: {
    mainListStyles () {
      return this.submenu.depth ? `transform: translateX(${this.submenu.depth * 100}%)` : false
    },
    ...mapState({
      submenu: state => state.ui.submenu,
      currentUser: state => state.user.current
    }),
    getSubmenu () {
      return this.submenu
    },
    visibleCategories () {
      return this.categories.filter(category => {
        return category.product_count > 0 || category.children_count > 0
      })
    },
    isCurrentMenuShowed () {
      return !this.getSubmenu || !this.getSubmenu.depth
    }
  },
  watch: {
    isOpen: {
      handler (isOpen) {
        this.handleScroll(isOpen)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.componentLoaded = true
    })
    this.handleScroll(this.isOpen)
  },
  methods: {
    close () {
      this.clearAllBodyScrollLocks()
      this.closeMenu()
    },
    handleScroll (showBlock) {
      if (showBlock) {
        this.disableBodyScroll()
      }
    },
    login () {
      if (!this.currentUser && this.isCurrentMenuShowed) {
        this.$nextTick(() => {
          this.$store.commit('ui/setAuthElem', 'login')
          this.$bus.$emit('modal-show', 'modal-signup')
          this.$router.push({ name: 'my-account' })
          this.close()
        })
      }
    },
    categoryLink (category) {
      return formatCategoryLink(category)
    },
    goToRegisterPage () {
      this.$store.commit('ui/setAuthElem', 'register')
      this.$bus.$emit('modal-show', 'modal-signup')
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~theme/css/animations/transitions";
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';

.sidebar-menu {
  height: 100%;
  width: 350px;
  overflow: hidden;

  @media (max-width: 767px) {
    width: 100vh;
  }

  &__container {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    height: calc(100% - 51px);
  }

  &__list {
    height: max-content;
    overflow-y: auto;
    transition: transform $duration-main $motion-main;
    padding-bottom: 300px;

    .block {
      border-bottom: 1px solid #626262;
      background-color: transparent;
      padding: 16px 4px;
      justify-content: start;
      width: 100%;
      font-weight: 700;
      line-height: 22px;
      font-size: 18px;
    }
  }

  ul {
    list-style-type: none;
  }

  li {
    &:hover,
    &:focus {
      background-color: color(transparent);
    }
  }

  .details {
    background-color: #1a1a1a;

    .icon {
      width: 18px;
      height: 18px;
    }
  }
}

.logo-container {
  height: 41px;
}

.account-details {
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>
